<template>
  <div>
    <section v-if="showPageDeclarations" class="page-declaration-bar">
      <div class="container declaration-container">
        <div class="declaration-content" v-html="activePageDeclaration.content" />
      </div>
    </section>
    <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-bottom-row">
          <div class="footer-section">
            <h4>本网动态</h4>
            <ul class="footer-links">
              <li><router-link to="/dynamics?category=platform">平台公告</router-link></li>
              <li><router-link to="/events?from=carousel&filter=non_policy">行业资讯</router-link></li>
              <li><router-link to="/events">政策法规</router-link></li>
              <li><router-link to="/policies">平台政策</router-link></li>
            </ul>
          </div>
          <div class="footer-section">
            <h4>本网服务</h4>
            <ul class="footer-links">
              <li><a href="#" @click.prevent="goToMerchantRegister">产品推介</a></li>
              <li><a href="#" @click.prevent="goToMerchantRegister">企业入驻</a></li>
              <li><a href="#" @click.prevent="goToPublishDemand">需求发布</a></li>
              <li><router-link to="/thinktank">专家咨询</router-link></li>
            </ul>
          </div>
          <div class="footer-section">
            <h4>常用网址</h4>
            <ul class="footer-links">
              <li><a href="https://www.mem.gov.cn/" target="_blank" rel="noopener noreferrer">应急管理部</a></li>
              <li><a href="https://mempe.org.cn/" target="_blank" rel="noopener noreferrer">应急宣教中心</a></li>
              <li><a href="https://www.chinasafety.ac.cn/" target="_blank" rel="noopener noreferrer">安全生产研究院</a></li>
              <li><a href="http://www.cciph.com.cn/" target="_blank" rel="noopener noreferrer">应急出版社</a></li>
            </ul>
          </div>
          <div class="footer-section">
            <h4>法律声明</h4>
            <ul class="footer-links">
              <li><a href="javascript:void(0)" @click.prevent="goToDeclaration('legal')">法律声明</a></li>
              <li><a href="javascript:void(0)" @click.prevent="goToDeclaration('privacy')">隐私声明</a></li>
              <li><a href="javascript:void(0)" @click.prevent="goToDeclaration('terms')">服务条款</a></li>
              <li><a href="javascript:void(0)" @click.prevent="goToDeclaration('disclaimer')">免责声明</a></li>
            </ul>
          </div>
          <div class="footer-section">
            <h4>技术支持</h4>
            <ul class="footer-links">
              <li><a href="javascript:void(0)" @click.prevent="goToSupportCategory('help')">帮助中心</a></li>
              <li><a href="javascript:void(0)" @click.prevent="goToSupportCategory('guide')">使用指南</a></li>
              <li><a href="javascript:void(0)" @click.prevent="goToSupportCategory('faq')">常见问题</a></li>
              <li><router-link to="/support">在线客服</router-link></li>
            </ul>
          </div>
          <div class="footer-section">
            <h4>联系方式</h4>
            <ul class="footer-links">
              <li v-if="contactInfo && contactInfo.sponsor">
                <span>{{ contactInfo.sponsor_label || '主办单位' }}：{{ contactInfo.sponsor }}</span>
              </li>
              <li v-if="contactInfo && contactInfo.phone">
                <a :href="`tel:${contactInfo.phone}`">{{ contactInfo.phone_label || '服务热线' }}：{{ contactInfo.phone }}</a>
              </li>
              <li v-if="contactInfo && contactInfo.email">
                <a :href="`mailto:${contactInfo.email}`">{{ contactInfo.email_label || '电子邮箱' }}：{{ contactInfo.email }}</a>
              </li>
              <li v-if="contactInfo && contactInfo.address">
                <span>{{ contactInfo.address_label || '办公地址' }}：{{ contactInfo.address }}</span>
              </li>
              <li v-if="!contactInfo || (!contactInfo.sponsor && !contactInfo.phone && !contactInfo.email && !contactInfo.address)">
                <span>加载中...</span>
              </li>
            </ul>
          </div>
          <div class="footer-section footer-qrcode">
            <h4>扫码关注</h4>
            <div class="qrcode-container">
              <div class="qrcode-item">
                <img src="@/assets/imgs/xcx.jpg" alt="小程序二维码" class="qrcode-img">
              </div>
            </div>
          </div>
        </div>
        
        <div class="footer-top-row">
          <div class="footer-section">
            <h4 class="footer-title">关于平台</h4>
            <p class="footer-description">基于《安全应急产业分类指导目录（2021年版）》构建的专业产品展示平台</p>
          </div>
          <div class="footer-section footer-slogan">
            <p class="footer-slogan-text">人人讲安全 个个会应急</p>
          </div>
        </div>
      </div>
      
      <div class="footer-bottom">
        <p><a href="https://beiancx.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer" class="beian-link">鲁ICP备2025140202号-1</a> &nbsp;|&nbsp; &copy; 2025 应急科技推介. 保留所有权利.</p>
        <p class="footer-tech-support">技术支持：<a href="https://qecos.com/" target="_blank" rel="noopener noreferrer">山东洪华大数据集团有限公司</a></p>
      </div>
    </div>
    </footer>
  </div>
</template>

<script>
import { config } from '@/config'

export default {
  name: 'Footer',
  data() {
    return {
      contactInfo: null,
      pageDeclarations: []
    }
  },
  computed: {
    merchantRegisterUrl() {
      // 从配置文件获取merchant端注册页面URL
      return `${config.merchantBaseUrl}/register`
    },
    currentPageKey() {
      const path = this.$route.path || ''
      if (path === '/products') return 'product_list'
      if (/^\/products\/\d+/.test(path)) return 'product_detail'
      if (path === '/emergency-enterprises') return 'enterprise_list'
      if (/^\/enterprise\/\d+/.test(path)) return 'enterprise_detail'
      if (path === '/thinktank') return 'expert_list'
      if (/^\/expert\/\d+/.test(path)) return 'expert_detail'
      return ''
    },
    showPageDeclarations() {
      return !!this.activePageDeclaration
    },
    activePageDeclaration() {
      return this.pageDeclarations.length > 0 ? this.pageDeclarations[0] : null
    }
  },
  mounted() {
    this.fetchContactInfo()
    this.fetchPageDeclarations()
  },
  watch: {
    '$route.path'() {
      this.fetchPageDeclarations()
    }
  },
  methods: {
    async fetchPageDeclarations() {
      this.pageDeclarations = []
      if (!this.currentPageKey) return
      try {
        const response = await fetch(`/api/page-declarations/by-page/${this.currentPageKey}?limit=1`)
        if (!response.ok) return
        const data = await response.json()
        this.pageDeclarations = data.items || []
      } catch (error) {
        this.pageDeclarations = []
      }
    },
    async fetchContactInfo() {
      try {
        // 根据环境自动判断API地址
        const API_BASE_URL = process.env.NODE_ENV === 'development' 
          ? 'http://localhost:8888/api' 
          : (() => {
              if (typeof window !== 'undefined') {
                const hostname = window.location.hostname
                const protocol = window.location.protocol
                // 生产环境：自动使用当前域名
                if (hostname.includes('zgyjkj.com')) {
                  return `${protocol}//${hostname}/api`
                }
              }
              return 'https://www.zgyjkj.com/api'
            })()
        const response = await fetch(`${API_BASE_URL}/platform-intro/contact`)
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        const data = await response.json()
        this.contactInfo = data
      } catch (error) {
        console.error('❌ [页脚联系方式] 加载失败:', error)
        // 加载失败时使用默认值
        this.contactInfo = {
          sponsor: '应急管理部宣传教育中心',
          phone: '待补充',
          email: '待补充',
          address: '待补充'
        }
      }
    },
    goToMerchantRegister() {
      // 在新标签页打开merchant端的注册页面
      window.open(this.merchantRegisterUrl, '_blank')
    },
    async goToPublishDemand() {
      try {
        // 检查用户是否登录
        const token = localStorage.getItem('token')
        if (!token) {
          this.$message.warning('请先登录')
          this.$router.push('/login')
          return
        }

        // 获取用户信息
        const { getUserInfo } = await import('@/utils/api')
        const userInfo = await getUserInfo()
        const user = userInfo.data || userInfo

        // 跳转到merchant端的用户中心发布需求页面（在新标签页打开）
        const merchantUrl = `${config.merchantBaseUrl}/user-center?token=${encodeURIComponent(token)}&activeMenu=publish`
        window.open(merchantUrl, '_blank')
      } catch (error) {
        console.error('检查用户权限失败:', error)
        // 如果获取用户信息失败，可能是未登录或token过期
        if (error.response && error.response.status === 401) {
          // 不显示提示信息，静默处理
          localStorage.removeItem('token')
          // 不自动跳转，让用户继续浏览
        } else {
          this.$message.error('检查用户权限失败，请重试')
        }
      }
    },

    // 跳转到声明详情页
    goToDeclaration(code) {
      this.$router.push(`/declaration/${code}`)
    },

    // 跳转到技术支持分类的第一个文章详情页
    async goToSupportCategory(category) {
      try {
        // 根据环境自动判断API地址
        const API_BASE_URL = process.env.NODE_ENV === 'development'
          ? 'http://localhost:8888/api'
          : (() => {
              if (typeof window !== 'undefined') {
                const hostname = window.location.hostname
                const protocol = window.location.protocol
                // 生产环境：自动使用当前域名
                if (hostname.includes('zgyjkj.com')) {
                  return `${protocol}//${hostname}/api`
                }
              }
              return 'https://www.zgyjkj.com/api'
            })()

        // 获取该分类下的第一篇文章
        const response = await fetch(`${API_BASE_URL}/support/?category=${category}&limit=1&status=published`)

        if (response.ok) {
          const data = await response.json()
          if (data.code === 200 && data.data && data.data.items && data.data.items.length > 0) {
            const firstArticle = data.data.items[0]
            this.$router.push(`/support/${firstArticle.id}`)
          } else {
            // 如果没有文章，跳转到支持列表页并显示提示
            this.$message.info('该分类暂无内容')
            this.$router.push(`/support?category=${category}`)
          }
        } else {
          throw new Error('获取支持列表失败')
        }
      } catch (error) {
        console.error('获取技术支持列表失败:', error)
        this.$message.error('获取内容失败，请稍后重试')
        // 出错时跳转到列表页
        this.$router.push(`/support?category=${category}`)
      }
    }
  }
}
</script>

<style scoped>
/* 直接使用 styles.css 中的 footer 样式 */
.footer {
  background: #2c3e50;
  color: white;
  padding: 0.5rem 0 0.5rem;
}

.page-declaration-bar {
  background: #f7f9fc;
  border-top: 1px solid #e8edf5;
  border-bottom: 1px solid #e8edf5;
  padding: 10px 0;
}

.declaration-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 0;
}

.declaration-link {
  padding: 0;
  font-size: 14px;
}

.declaration-content {
  width: 100%;
  max-width: 1000px;
  line-height: 1.8;
  text-align: center;
  color: #334155;
}

.declaration-content :deep(p) {
  margin: 0.25em 0;
}

.footer p {
  font-size: 14px;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 0.3rem;
}

.footer-top-row {
  display: grid;
  grid-template-columns: 1fr 1fr; /* 改为两列布局 */
  gap: 2rem;
  margin-bottom: 0.3rem;
}

.footer-bottom-row {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 1rem;
}

.footer-title {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.footer-description {
  color: #bdc3c7;
  line-height: 1.6;
}

/* 宣传语样式 - 简洁行书风格 */
.footer-slogan {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.footer-slogan-text {
  color: #fff !important;
  font-size: 2.8rem !important;
  font-weight: normal !important;
  line-height: 1.4;
  margin: 0;
  letter-spacing: 4px;
  font-family: "STXingkai", "华文行楷", "FZXingKai-S04S", "方正行楷简体", "KaiTi", "楷体", "SimKai", cursive, serif;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 0.5rem;
}

.footer-links a {
  color: #bdc3c7;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: white;
  text-decoration: none; /* 确保所有页脚链接hover时都没有下划线 */
}


.footer-bottom {
  text-align: center;
  padding-top: 0.5rem;
  border-top: 1px solid #34495e;
  color: #bdc3c7;
}

.footer-tech-support {
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: #95a5a6;
}

.footer-tech-support a {
  color: #95a5a6;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-tech-support a:hover {
  color: #fff;
  text-decoration: none; /* 移除下划线 */
}

/* 备案号链接样式 */
.beian-link {
  color: #bdc3c7;
  text-decoration: none;
  transition: color 0.3s ease;
}

.beian-link:hover {
  color: #fff;
  text-decoration: none; /* 移除下划线 */
}

.footer-section h4 {
  color: #fff;
  margin-bottom: 0.8rem;
  font-size: 1rem;
  font-weight: 600;
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-section ul li {
  margin-bottom: 0.5rem;
}

.footer-section ul li a,
.footer-section ul li span {
  color: #ccc;
  text-decoration: none;
  transition: color 0.3s ease;
  font-size: 0.85rem;
  white-space: nowrap;
}

.footer-section ul li a:hover {
  color: #fff;
}

.footer-section p {
  color: #ccc;
  margin-bottom: 0.4rem;
  font-size: 0.85rem;
  line-height: 1.5;
}

/* 二维码样式 */
.footer-qrcode {
  text-align: center;
}

.qrcode-container {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 10px;
}

.qrcode-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.qrcode-img {
  width: 90px;
  height: 90px;
  border: 2px solid #fff;
  border-radius: 8px;
  object-fit: cover;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background: white;
}

.qrcode-img:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);
}

.qrcode-label {
  color: #bdc3c7;
  font-size: 12px;
  margin: 0;
}

/* Footer响应式设计 */
@media (max-width: 768px) {
  .footer-top-row {
    grid-template-columns: 1fr; /* 小屏幕时改为单列 */
    gap: 1.5rem;
  }
  
  .footer-slogan {
    padding: 15px;
  }
  
  .footer-slogan-text {
    font-size: 2.2rem !important; /* 小屏幕字号 */
    letter-spacing: 3px;
  }
  
  .footer-bottom-row {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
  
  .footer-section h4 {
    font-size: 1rem;
  }
  
  .footer-section ul li a,
  .footer-section p {
    font-size: 0.85rem;
  }
  
  .qrcode-img {
    width: 70px;
    height: 70px;
  }
}

@media (max-width: 480px) {
  .footer-top-row {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .footer-slogan {
    padding: 12px;
  }
  
  .footer-slogan-text {
    font-size: 1.8rem !important;
    letter-spacing: 2px;
  }
  
  .footer-bottom-row {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}
</style> 